/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { RESTRICTED_NAMESPACES } from '../../Constants/ComponentSet.constants';

/**
 * Is the component set restricted from being edited.
 * @param {string} webPath The web path for the component screen (must not start with '/').
 * @export
 * @returns {boolean} Is the component set restricted or not.
 */
export const isSetNamespaceRestricted = (webPath: string): boolean => {
  const isRestrictedNamespace = RESTRICTED_NAMESPACES.find((restrictedNamespace) => {
    if (webPath.toLocaleLowerCase().startsWith(restrictedNamespace)) {
      return true;
    }
    return false;
  });

  return !!isRestrictedNamespace;
};
